import * as React from 'react';
import { isEmpty, get } from 'lodash';
import { PAYMENT_MODE, BANK_CODE } from 'pages/PaymentsPage/PaymentOptions/constants';
import { getEMIInstrumentCheck } from './OnSavedCardOptions';
import styles from './OnSavedCardMessage.css';
export const shouldEnableEMIOnSavedCardsFlow = ({ props, instrumentCheck }) => {
    // Shim to ensure that we don't have to change a lot of code post adding
    // the emi on saved cards flow check flag in fetch payment options response
    const customFlagSetInModifiedResponse = get(props, 'option.emi_on_saved_cards');
    if (customFlagSetInModifiedResponse === true) {
        return true;
    }
    // Don't enable this flow if the card is inside the EMI section
    if (props.cardKey || !props || !instrumentCheck) {
        return false;
    }
    const paymentModes = get(instrumentCheck, 'payment_modes', []);
    if (paymentModes.length === 1 && paymentModes[0] === PAYMENT_MODE.FULL_PAYMENT) {
        return false;
    }
    const emiIC = getEMIInstrumentCheck({ instrumentCheck });
    return !isEmpty(emiIC);
};
export const shouldShowEMITenuresDirectly = ({ instrumentCheck }) => {
    const paymentModes = get(instrumentCheck, 'payment_modes', []);
    if (!paymentModes || !paymentModes.length) {
        return false;
    }
    if (paymentModes.length === 1 && paymentModes[0] === PAYMENT_MODE.EMI_PAYMENT) {
        return true;
    }
    return false;
};
// not using explicit types here because this is supposed to be removed after
// the EMI on saved cards experiment concludes and we enable/disable it for
// everyone.
//
// When a bajaj finserv saved card is coming in the payment options, avoid
// showing the option if the user doesn't fall into the EMI on saved cards
// bucket
export const shouldSkipRender = ({ option, isEMIOnSavedCardsFlow }) => {
    const bankCode = get(option, 'card_information.bank_code');
    if (isEmpty(option) || (!isEMIOnSavedCardsFlow && bankCode === BANK_CODE.BAJAJFINSERV)) {
        return true;
    }
    return false;
};
function OnSavedCardMessage(props) {
    const message = get(props, 'option.emi_display_text', '');
    const isEMIOnSavedCardsFlow = get(props, 'option.emi_on_saved_cards');
    if (!message || props.checked || !isEMIOnSavedCardsFlow) {
        return null;
    }
    return <p className={styles['message']}>{message}</p>;
}
export { OnSavedCardMessage };
